exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-094624d0]{color:#fff;background-color:#009efb}.page-title[data-v-094624d0]{font-size:24px;font-weight:700;text-align:center;text-transform:uppercase}.footer[data-v-094624d0]{background-color:#999;color:#f0f0f0;padding:32px;justify-self:end}[data-v-094624d0] .v-image__image--cover{background-size:contain}", ""]);

// exports
